import script from "./CreateProjectStep4.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateProjectStep4.vue?vue&type=script&setup=true&lang=js"

import "./CreateProjectStep4.vue?vue&type=style&index=0&id=62ee7ade&lang=scss&scoped=true"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62ee7ade"]])

export default __exports__